import { useCallback } from 'react';

import { parseMapSearchParams } from '@app/helpers';
import { initMapSearchFromUrlAction, setFiltersVisibilityAction, useAppDispatch } from '@app/state';

/**
 * Hook to initialize map search state from URL parameters
 * @returns Function to initialize map search from URL
 */
export function useMapSearchInitializer() {
    const dispatch = useAppDispatch();

    return useCallback(
        async (
            searchParams: URLSearchParams | Record<string, string>,
            isMobileRes?: boolean,
        ): Promise<void> => {
            const { searchCriteria, filters } = parseMapSearchParams(searchParams);
            dispatch(
                initMapSearchFromUrlAction({
                    searchCriteria,
                    filters,
                }),
            );

            if (isMobileRes !== undefined) {
                // Open filters on desktop
                const shouldOpenFilters = !isMobileRes;
                dispatch(setFiltersVisibilityAction({ open: shouldOpenFilters }));
            }
        },
        [],
    );
}
